import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import useMessageFetcher from '../hooks/useMessageFetcher'
import Message from '../interfaces/Message'

import MessageDetail from './MessageDetail'

const MessageDetailPage: React.FC = () => {
  // Extracting id parameter from the route
  const { id } = useParams<{ id: string }>()
  const { fetchMessageDetail, errorMessage } = useMessageFetcher()
  const [message, setMessage] = useState<Message>()
  const [refreshKey, setRefreshKey] = useState(0) // A key to trigger re-fetching

  useEffect(() => {
    if (!id) {
      return // Exit early if `id` is undefined
    }

    const fetchDataAsync = async () => {
      const data = await fetchMessageDetail(id)

      if (!data) return
      setMessage(data)
    }

    fetchDataAsync()
  }, [id, refreshKey])

  const handleRefresh = () => setRefreshKey((prev) => prev + 1) // Increment the refreshKey to trigger re-fetch

  return (
    <>
      {!!message && <MessageDetail message={message} onRefresh={handleRefresh} />}
      <div>{errorMessage?.message}</div>
    </>
  )
}

export default MessageDetailPage
